// 关键词高亮（虚拟 DOM 渲染）
// 以文本节点 + 高亮 span 的 VNode 形式渲染，用户数据始终作为文本节点创建并被框架自动转义，
// 从根本上避免 v-html 渲染后端字符串带来的 XSS 风险，且无需引入额外依赖。
export default {
    name: 'HighlightText',
    functional: true,
    props: {
        // 纯文本内容
        text: {
            type: [String, Number],
            default: '',
        },
        // 需要高亮的关键词
        keyword: {
            type: String,
            default: '',
        },
        // 高亮节点的样式（默认沿用表格强调色）
        highlightStyle: {
            type: Object,
            default() {
                return { color: '#E03A3E' };
            },
        },
    },
    render(h, { props }) {
        const text = props.text == null ? '' : String(props.text);
        const keyword = (props.keyword || '').trim();

        // 无关键词或未命中，直接作为纯文本渲染
        if (!keyword || text.indexOf(keyword) < 0) {
            return h('span', text);
        }

        const children = [];
        let rest = text;
        let idx = rest.indexOf(keyword);

        // 按关键词逐段切分：命中段用高亮 span，其余为纯文本节点
        while (idx >= 0) {
            if (idx > 0) {
                children.push(rest.slice(0, idx));
            }

            children.push(h('span', { style: props.highlightStyle }, keyword));

            rest = rest.slice(idx + keyword.length);
            idx = rest.indexOf(keyword);
        }

        if (rest) {
            children.push(rest);
        }

        return h('span', children);
    },
};
